import Store from '../../../Store';
import {
    insertCallLog,
    fetchingCallLog
} from '../../../Actions/CallLogAction';
import SDK from '../../SDK.js';

let totalPages = 0;

const callLogs = {
    getCallLogsFromServer: async function (pageNumber = 1) {
        if (pageNumber === 1 || pageNumber < totalPages) {
            const logs = await SDK.getCallLogs(pageNumber);
            if (logs.statusCode === 200) {
                totalPages = logs.data.totalPages;
                callLogs.setLocalData(logs.data.callLogs);
                Store.dispatch(fetchingCallLog(false));
            } else {
                Store.dispatch(fetchingCallLog(false));
            }
        } else {
            Store.dispatch(fetchingCallLog(false));
        }
    },
    setLocalData: function (callLogsData) {
        const toUserArray = (value) =>
            (Array.isArray(value) ? value : (value ? String(value).split(',') : [])).filter(Boolean);
        callLogsData.map((callLog) => {
            const existing = callLogs.getCallLogByRoomId(callLog.roomId);
            if (!existing) {
                Store.dispatch(insertCallLog(callLog));
                return undefined;
            }
            // Never let an incoming record shrink the participant list. The server's
            // in-progress (ringing) record can carry an incomplete userList (e.g.
            // "917339476320," with a participant dropped); a wholesale replace would
            // clobber a complete local entry and the call log would then show only the
            // caller until the call fully closes. Union the two lists so participants
            // are only ever added, never lost. Server-authoritative fields (endTime,
            // sessionStatus, callState…) still win via the spread below.
            const unionArr = [];
            toUserArray(existing.userList).concat(toUserArray(callLog.userList)).forEach((user) => {
                if (unionArr.indexOf(user) === -1) unionArr.push(user);
            });
            const unionUserList = unionArr.join(',');
            const merged = { ...existing, ...callLog };
            if (unionUserList) {
                merged.userList = unionUserList;
                merged.toUser = unionUserList;
            }
            // Don't let an incomplete incoming record downgrade a group call. The
            // server's in-progress record reports callMode "onetoone" because it
            // computed it from its incomplete (single-user) userList; the local insert
            // already recorded the correct "onetomany" (it runs before this merge), so
            // preserve it instead of flipping the call log to a one-to-one. Only key off
            // an explicit callMode — NOT groupId, which the server populates with a
            // room/MUC id even for genuine one-to-one calls and would wrongly upgrade
            // them. Only ever preserve/upgrade onetomany, never downgrade.
            if (existing.callMode === "onetomany" || callLog.callMode === "onetomany") {
                merged.callMode = "onetomany";
            } else if (!merged.callMode && existing.callMode) {
                merged.callMode = existing.callMode;
            }
            // Preserve a valid callTime. The call log is sorted by callTime, but the
            // server's in-progress record can carry callTime 0 (the time is finalised
            // only when the call closes). Letting that 0 overwrite the real creation
            // time sorts a brand-new call to the BOTTOM of the list until it closes —
            // the intermittent re-order. Keep the existing time when the incoming one
            // is missing/zero. Same for startTime, which feeds the call duration.
            if (!merged.callTime && existing.callTime) {
                merged.callTime = existing.callTime;
            }
            if (!merged.startTime && existing.startTime) {
                merged.startTime = existing.startTime;
            }
            Store.dispatch(insertCallLog(merged));
            return undefined;
        });
    },
    getCallLogByRoomId: function (roomId) {
        const state = Store.getState();
        const callLogsData = state.callLogData.callLogs;
        return callLogsData[roomId] || null;
    },
    initTime: function () {
        return new Date().getTime() * 1000;
    },
    insert: function (callLog) {
        if (!callLog?.roomId) {
            return;
        }
        const userList = callLog.userList && Array.isArray(callLog.userList) ? callLog.userList.join(',') : callLog.userList;
        let postData = {
            "callLogs": [{
                "callMode": callLog.callMode || '',
                "callState": callLog.callState ? callLog.callState : '',
                "callType": callLog.callType || '',
                "callerDevice": "WEB",
                "callTime": callLog.callTime || 0,
                "startTime": callLog.startTime || 0,
                "endTime": callLog.endTime || 0,
                "fromUser": callLog.fromUser || '',
                "inviteUserList": callLog.inviteUserList || "",
                "roomId": callLog.roomId || '',
                "sessionStatus": callLog.sessionStatus || "",
                "toUser": userList || '',
                "userList": userList || '',
                "groupId": callLog.groupId || ''
            }]
        }
        callLogs.setLocalData(postData.callLogs);
    },
    update: async function (roomId, callLogToUpdate) {
        if (!roomId || !callLogToUpdate) {
            return;
        }
        let callLog = await callLogs.getCallLogByRoomId(roomId);
        if (!callLog) {
            return;
        }

        let userListToUpdate = callLog.userList;
        // Below we handled If new userList need to update, then compare with the existing users
        // & then update the new user which are not in existed users.
        if (callLogToUpdate.userList) {
            const existedUserList = callLog.userList;
            userListToUpdate = callLogToUpdate.userList;
            if (existedUserList) {
                const existedUserListArr = Array.isArray(existedUserList) ? existedUserList : existedUserList.split(',');
                const userListToUpdateArr = Array.isArray(userListToUpdate) ? userListToUpdate : userListToUpdate.split(',');
                userListToUpdateArr.map((newUser) => {
                    if (existedUserListArr.indexOf(newUser) === -1) {
                        existedUserListArr.push(newUser);
                    }
                    return true;
                });
                userListToUpdate = existedUserListArr.join(',');
            }
        }
        callLogToUpdate['toUser'] = userListToUpdate;
        callLogToUpdate['userList'] = userListToUpdate;

        callLogToUpdate = {
            ...callLog,
            ...callLogToUpdate
        };
        let postData = {
            "callLogs": [callLogToUpdate]
        }
        callLogs.setLocalData(postData.callLogs);
    }
}

export default callLogs;
